/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontCallButton_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"CallDealerModal_viewer">;
    readonly " $refType": "StorefrontCallButton_viewer";
};
export type StorefrontCallButton_viewer$data = StorefrontCallButton_viewer;
export type StorefrontCallButton_viewer$key = {
    readonly " $data"?: StorefrontCallButton_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontCallButton_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontCallButton_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CallDealerModal_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'c67b43dc7930e02a0641e35b3ae5393a';
export default node;
